export default __webpack_public_path__ + "static/media/vento.7a7f92b8.glb";